import { useSelector } from "react-redux";
import { useMemo } from "react";
import styles from "./index.module.scss";
import { installPropNames } from "../../../../utils/constants";

export default function InstallPriceNew({ product }) {
  const { sections } = useSelector((state) => state.sections);
  const { host } = useSelector((state) => state.params);

  // eslint-disable-next-line no-use-before-define
  const installPricePerHour = getInstallPricePerHour("635", sections, host);
  const farkopInstallTime = product.VREMYA_USTANOVKI;

  const installPrice = useMemo(() => {
    // eslint-disable-next-line no-use-before-define

    if (installPricePerHour && product.VREMYA_USTANOVKI) {
      const price = Math.round((installPricePerHour / 60) * farkopInstallTime);
      // if (product.INSTALL_COEFFICIENT) {
      //   price = round((price * product.INSTALL_COEFFICIENT) / 100);
      // }
      return price;
    }
    return 0;
  }, []);

  const additionalIstallPrices = useMemo(() => {
    return Object.keys(installPropNames)
      .filter((propCode) => !installPropNames[propCode].includes("Подкл"))
      .filter((propCode) => propCode !== "VREMYA_USTANOVKI")
      .filter((propCode) => product.INSTALL[propCode])
      .map((propCode) => {
        return {
          name: installPropNames[propCode],
          price: Math.round(
            (installPricePerHour / 60) * product.INSTALL[propCode],
          ),
        };
      })
      .sort((a, b) => a.price - b.price);
  });

  return (
    <>
      {installPrice > 0 && (
        <div className={styles.Install}>
          <span>
            С установкой без электрики <b>+{installPrice} руб </b>
            {/* ({farkopInstallTime}{" "}
            мин {installPricePerHour} руб/ч ) */}
          </span>
        </div>
      )}
      {additionalIstallPrices.map((item) => (
        <div className={styles.Install} key={item.name}>
          <span>
            {item.name} <b>+{item.price} руб </b>
          </span>
        </div>
      ))}
    </>
  );
}

const getInstallPricePerHour = (sectionId, sections, host) => {
  if (!sections[sectionId]?.UF_INSTALL_PRICE) {
    return 0;
  }
  const subDomain = host.split(".")[0];
  if (!["msk", "spb"].includes(subDomain)) {
    return 0;
  }

  const sectionHourPrices = {};
  sections[sectionId].UF_INSTALL_PRICE.forEach((item) => {
    const itemArray = item.split(":");
    sectionHourPrices[itemArray[0]] = +itemArray[1];
  });
  return sectionHourPrices[subDomain];
};
